import React from "react";
import {
  FaInstagram,
  FaLinkedin,
  FaSquareFacebook,
  FaTwitter,
} from "react-icons/fa6";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <div className="container-fluid p-0">
        <footer
          className="text-center text-lg-start text-dark"
          style={{ background: "linear-gradient(to right, #fefeff, #1891c8)" }}
        >
          <section
            className="d-flex justify-content-between align-items-center text-white py-4"
            style={{ backgroundColor: "#000" }}
          >
            {/* Company Name */}
            <div className="ms-4">
              <h5 className="text-white mb-0">ASTITVA LOGISTICS</h5>
            </div>
            {/* Social Media Icons */}
            <div>
              <Link to="/" className="text-white me-4 social-icon">
                <FaSquareFacebook />
              </Link>
              <Link to="/" className="text-white me-4 social-icon">
                <FaTwitter />
              </Link>

              <Link to="/" className="text-white me-4 social-icon">
                <FaInstagram />
              </Link>
              <Link to="/" className="text-white me-4 social-icon">
                <FaLinkedin />
              </Link>
            </div>
          </section>

          {/* Main Footer Content */}
          <section className="">
            <div className="container text-center text-md-start mt-5">
              <div className="row mt-3">
                {/* Company Info */}
                <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                  <h6 className="text-uppercase fw-bold">
                    Fashnear Technologies Private Limited
                  </h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{
                      width: "60px",
                      backgroundColor: "#7c4dff",
                      height: "2px",
                    }}
                  />
                  <p>
                    Fashnear Technologies Private Limited, CIN:
                    U74900KA2015PTC082263 3rd Floor, Wing-E, Helios Business
                    Park,Kadubeesanahalli Village, Varthur Hobli, Outer Ring
                    Road Bellandur, Bangalore, Bangalore South, Karnataka,
                    India, 560103
                  </p>
                </div>

                {/* Useful Links */}
                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                  <h6 className="text-uppercase fw-bold">Legal</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{
                      width: "60px",
                      backgroundColor: "#7c4dff",
                      height: "2px",
                    }}
                  />
                  <p>
                    <Link to="/account" className="text-dark">
                      Privacy Policy
                    </Link>
                  </p>
                  <p>
                    <Link to="/affiliate" className="text-dark">
                      Terms of use
                    </Link>
                  </p>
                </div>

                {/* Contact Section */}
                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                  <h6 className="text-uppercase fw-bold">Contact</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{
                      width: "60px",
                      backgroundColor: "#7c4dff",
                      height: "2px",
                    }}
                  />
                  <p>
                    <i className="fas fa-home mr-3"></i> New York, NY 10012, US
                  </p>
                  <p>
                    <i className="fas fa-envelope mr-3"></i> info@example.com
                  </p>
                  <p>
                    <i className="fas fa-phone mr-3"></i> + 01 234 567 88
                  </p>
                  <p>
                    <i className="fas fa-print mr-3"></i> + 01 234 567 89
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Copyright Section */}
          <div
            className="text-center p-3"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
          >
            Copyright © 2025.
            <Link className="text-dark" to="/">
              All rights reserved.
            </Link>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
